import { useSearchParams } from 'react-router-dom'

import { Text } from '@interco/inter-ui/components/Text'

import * as S from './style'

type Content = {
  id: number
  title: string
  description: string
}

const AboutContent: Content[] = [
  {
    id: 1,
    title: 'O que são dados enviados?',
    description:
      'Processo em que você autoriza diferentes instituições financeiras a acessarem suas informações financeiras de forma segura.\n\nIsso inclui dados como saldos, transações e informações pessoais.',
  },
  {
    id: 2,
    title: 'O que são dados recebidos?',
    description:
      'Processo em que você autoriza o Inter a acessar suas informações de forma segura em diferentes instituições financeiras.\n\nIsso inclui dados como saldos, transações e informações pessoais.',
  },
  {
    id: 3,
    title: 'O que são autorizações de dados enviados?',
    description:
      'São autorizações de instituições que podem acessar seus dados no Inter para diferentes propósitos a partir da sua autorização. Esse processo é feito via Open Finance.',
  },
  {
    id: 4,
    title: 'O que é Open Finance?',
    description:
      'Open Finance é um sistema gratuito no Inter que permite transações financeiras e compartilhamento seguro de dados entre instituições, sempre com a sua autorização.',
  },
  {
    id: 5,
    title: 'Posso encerrar o compartilhamento de dados quando eu quiser?',
    description: 'Sim, você pode encerrar o compartilhamento de dados a qualquer momento.',
  },
]

export const AboutSendData = () => {
  const [searchParams] = useSearchParams()
  const isCurrentTabInter = searchParams.get('tab') === 'INTER'

  const filterList = !isCurrentTabInter
    ? AboutContent.filter((content) => content.id !== 2)
    : AboutContent

  return (
    <S.Container>
      {filterList.map((content) => (
        <S.Content key={content.title}>
          <Text variant="body-1" bold colorWeight={500} style={{ fontSize: 18 }}>
            {content.title}
          </Text>
          <Text variant="body-2" style={{ fontSize: 14 }}>
            {content.description}
          </Text>
        </S.Content>
      ))}
    </S.Container>
  )
}
